import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ElvisDSModule } from 'ngx-elvis-ds';

import { SearchDialogPage } from './search-dialog.page';
import { GUIBaseModule } from '../../gui-base/gui-base.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        GUIBaseModule,
        ElvisDSModule,
    ],
    declarations: [
        SearchDialogPage,
    ]
})
export class SearchDialogPageModule {}
